import React, {useEffect, useRef, useState} from 'react';
import cl from "./FormLinkedItemListSelect.module.css";
import {Autocomplete, Button, Chip, CircularProgress, FormHelperText, TextField} from "@mui/material";
import ServerManager from "../API/ServerManager";
import FormControlCaption from "./FormControlCaption";

const ITEMS_PER_RQ_PAGE = 30;
const TYPING_TIMEOUT = 500; // [ms]

const FormRewardsSelect = ({
                               label,
                               initSelectedOptions,
                               initRefList,
                               apiName2,
                               inputWidthLimit,
                               controlRef,
                               selectedItemsAreaWidthLimit,
                               selectedItemsAreaType = "normal", // normal|column
                               onChange,
                               showIds,
                               renderItemExtraInfoFunc,
                               renderInitialItemExtraInfoFunc,
                               itemNameFunc,
                               filterExtraParams = {},
                               dataRefs,
                               readOnly,
                           }) => {

    const uniqIdCounter = useRef(0);

    // NOTE: исходную выборку сортируем по алфавиту. однако, при добавлении, новые элементы всегда будут вставляться в конец списка
    const [selectedOptions, setSelectedOptions] = useState(() => {
        return initSelectedOptions.map(x => ({
            id: x.id,
            name: getInitialOptionName(x.id, initRefList, itemNameFunc),
            yearsValue: getYearsText(x.year1, x.year2),
            yearsError: "",
            uniqId: ++uniqIdCounter.current,
            isInitial: true, // TODO? no need?
        })).sort((a, b) => {
            return a.name.localeCompare(b.name);
        });
    })

    const loadingOption = {id: -1, name: "loading", isLoading: true}
    const hintOption = {id: -2, name: "hint", isHint: true}
    const errorOption = {id: -3, name: "error", isError: true}

    const [mainOptions, setMainOptions] = useState([]);

    const [errorMessage, setErrorMessage] = useState("");

    const rqIdCounter = useRef(0);
    const [status, setStatus] = useState("closed"); // "", closed, idle, mainLoad, mainError, typing
    const [mainErrorMessage, setMainErrorMessage] = useState(""); // TODO!!
    const [lastTypingTime, setLastTypingTime] = useState(0);
    const [searchQuery, setSearchQuery] = useState("");

    const [ownDataRefs, setOwnDataRefs] = useState(dataRefs);

    useEffect(() => {
        if (controlRef) {
            controlRef.current = {
                getSelectedIds: () => selectedOptions.map(x => x.id),
                getSelectedOptions: () => selectedOptions.map(getResultOption),
                getIsEmpty: () => selectedOptions.length === 0,
                validateNotEmpty: validateNotEmpty,
                validateYears: validateYears,
                setErrorMessage: setErrorMessage,
            };
        }
    })

    function getResultOption(option) {
        const resultOption = { id: option.id };

        if (option.yearsValue) {
            const regex = /^(\d+)(\s*-\s*(\d+))?$/;
            const match = regex.exec(option.yearsValue.trim());
            if (!match)
                throw new Error(`invalid yearsValue: ${option.yearsValue}`);

            resultOption.year1 = parseInt(match[1]);
            resultOption.year2 = match[3] ? parseInt(match[3]) : null;
        }
        else {
            resultOption.year1 = null;
            resultOption.year2 = null;
        }

        return resultOption;
    }

    function validateYears() {
        let isValid = true;

        const newSelectedOptions = [...selectedOptions];

        for (const option of selectedOptions) {
            if (!validateYearsText(option.yearsValue)) {
                isValid = false;
                const newOption = {...option, yearsError: "Неверно указан год(ы)! Допустимы форматы: ГГГГ или ГГГГ-ГГГГ или пустое поле"}
                newSelectedOptions[selectedOptions.indexOf(option)] = newOption;
            }
        }

        // dups
        if (isValid) {
            for (const option1 of selectedOptions) {
                for (const option2 of selectedOptions) {
                    if (option1 !== option2 && option1.id === option2.id) {
                        const res1 = getResultOption(option1);
                        const res2 = getResultOption(option2);

                        if (res1.year1 === res2.year1) {
                            isValid = false;
                            const invalidOption = option1.uniqId > option2.uniqId ? option1 : option2;
                            const newOption2 = {...invalidOption, yearsError: "Повторяется год(ы)!"}
                            newSelectedOptions[selectedOptions.indexOf(invalidOption)] = newOption2;
                        }
                    }
                }
            }
        }


        if (!isValid)
            setSelectedOptions(newSelectedOptions);

        return isValid;
    }

    function validateNotEmpty(errorMessage) {
        if (selectedOptions.length > 0)
            return true;
        setErrorMessage(errorMessage);
        return false;
    }

    function handleSetSelectedOptions(value) {
        setSelectedOptions(value);
        if (onChange)
            onChange(value.map(x => x.id));
    }

    const [autocompleteOpen, setAutocompleteOpen] = useState(false);

    const correctedInputWidthLimit = inputWidthLimit === undefined ? 10000 : inputWidthLimit;
    const correctedSelectedItemsAreaWidthLimit = selectedItemsAreaWidthLimit === undefined ? 10000 : selectedItemsAreaWidthLimit;

    function filterOptions(options) {
        if (status === "mainLoad" || status === "typing")
            return [loadingOption];

        return options;
    }

    function getOptionLabel(option) {
        return option.name;
    }

    function getOptionKey(option) {
        return option.id;
    }

    function isOptionEqualToValue(option, value) {
        return option.id === value.id;
    }

    function onFilterEdit(forceUpdate = false) {
        setStatus("typing");
        setLastTypingTime(forceUpdate ? 0 : Date.now());
        setMainOptions([]);
        rqIdCounter.current++;
    }

    async function requestMainItems() {
        rqIdCounter.current++;
        const rqId = rqIdCounter.current;
        //console.log("rqId", rqId);

        setStatus("mainLoad")
        try {
            //await new Promise(resolve => setTimeout(resolve, 1000)); // temp!
            const data = await ServerManager.getSimpleModeFilteredList(apiName2, ITEMS_PER_RQ_PAGE, searchQuery, "name", "asc", 0, filterExtraParams);
            if (rqIdCounter.current === rqId) {
                const responseList = data[apiName2];
                // TODO? кешировать ответ, если общее кол-во опций мало? (чтобы не переспрашивать одно и то же)

                if (itemNameFunc) {
                    for (const item of responseList)
                        item.name = itemNameFunc(item);
                }

                if (!data.pagination.is_last)
                    responseList.push(hintOption);

                setMainOptions(responseList);
                setOwnDataRefs(data.refs);
                setStatus("idle");
            } else {
                console.log("rq answer ignored!");
            }
        } catch (error) {
            if (rqIdCounter.current === rqId) {
                setMainErrorMessage(`Ошибка при загрузке данных: ${error}`);
                setStatus("mainError");
                setMainOptions([errorOption]);
            }
        } finally {
            if (rqIdCounter.current !== rqId) {
                //console.log("ignored! rqId", rqId);
            }
        }
    }

    // запуск/продление временной задержки во время ввода текста
    useEffect(() => {
        async function wait() {
            const leftTime = lastTypingTime + TYPING_TIMEOUT - Date.now();
            if (leftTime > 0)
                await new Promise(resolve => setTimeout(resolve, leftTime));
            if (!ignore)
                requestMainItems();
        }

        if (status !== "typing")
            return;

        let ignore = false;
        wait();
        return () => {
            ignore = true;
        }

    }, [status, lastTypingTime]);

    function renderSelectedItem(item) {
        return <div key={item.uniqId}>
            <div style={{display: "flex", flexDirection: "row", gap: "10px", alignItems: "start"}}>
                <Chip
                    label={<div style={{display: "flex", gap: "5px", alignItems: "center"}}>
                        <span style={{whiteSpace: "wrap"}}>{item.name}</span>
                        {item.isInitial && renderInitialItemExtraInfoFunc && renderInitialItemExtraInfoFunc(item, cl.extraInfo)}
                        {!item.isInitial && renderItemExtraInfoFunc && renderItemExtraInfoFunc(item, cl.extraInfo, ownDataRefs)}
                        {showIds && renderIdInfo(item.id)}
                    </div>}
                    variant="outlined"
                    sx={{
                        backgroundColor: "#d0d0d0",
                        fontSize: "16px",
                        height: "min-content",
                        minHeight: "32px",
                        paddingTop: "4px",
                        paddingBottom: "4px"
                    }}
                    onDelete={readOnly ? undefined : () => {
                        handleSetSelectedOptions(selectedOptions.filter(x => x.uniqId !== item.uniqId));
                    }}
                />
                <TextField
                    type="text"
                    variant="outlined"
                    size={"small"}
                    hiddenLabel
                    value={item.yearsValue}
                    placeholder={"год(ы)"}
                    error={Boolean(item.yearsError)}
                    /*disabled={true}*/
                    //sx={{width: `min(${correctedWidthLimit}px, 100%)`}}
                    sx={{width: "120px", minWidth: "120px"}}
                    slotProps={{
                        /*htmlInput: {
                            sx: { backgroundColor: "white", borderRadius: "4px" }
                        },*/
                        input: {
                            ////readOnly: readOnly,
                            sx: {
                                ////backgroundColor: readOnly ? "#ffff0018" : "white",
                                backgroundColor: "white",
                                borderRadius: "4px",
                                /*pointerEvents: readOnly ? "none" : "auto",*/
                                height: "34px",
                            }
                        },
                        formHelperText: {
                            sx: {width: "max-content", maxWidth: "350px"}
                        }
                    }}
                    onChange={(event) => {
                        const newItem = {...item, yearsValue: event.target.value, yearsError: ""};
                        const newSelectedOptions = [...selectedOptions];
                        newSelectedOptions[selectedOptions.indexOf(item)] = newItem;
                        setSelectedOptions(newSelectedOptions);
                        if (errorMessage)
                            setErrorMessage("");
                    }}
                />
            </div>
            {item.yearsError && <FormHelperText error sx={{
                marginLeft: "14px",
                marginTop: "2px"
            }}>{item.yearsError}</FormHelperText>}
        </div>
    }

    function renderButton(label, onClick, sx) {
        return <Button variant="outlined" size="small" onClick={onClick} sx={sx}>{label}</Button>
    }

    return (
        <div className={cl.main}>
            <FormControlCaption
                text={label}
                tipText={"В дополнительном поле \"год(ы)\" укажите год в формате ГГГГ или пару лет в формате ГГГГ-ГГГГ или оставьте поле пустым"}
            />
            <div
                className={selectedItemsAreaType === "column" ? cl.selectedItemsArea_column : cl.selectedItemsArea_normal}
                style={{maxWidth: `min(${correctedSelectedItemsAreaWidthLimit}px, 100%)`}}>
                {selectedOptions.length > 0 ?
                    selectedOptions.map(renderSelectedItem) :
                    <span className={`${cl.emptyListLabel} ${errorMessage ? cl.error : ""}`}>(список пуст)</span>}
            </div>
            {autocompleteOpen ?
                <Autocomplete
                    open
                    renderInput={renderAutocompleteInput}
                    options={mainOptions}
                    sx={{width: `min(${correctedInputWidthLimit}px, 100%)`}}
                    disableClearable
                    autoHighlight /* при вводе текста сразу подсвечивается первый из доступных вариантов, что позволяет сразу клавишей Enter завершить выбор */
                    blurOnSelect /* после выбора, компонент теряет фокус */
                    filterOptions={filterOptions}
                    noOptionsText="Варианты не найдены"
                    getOptionLabel={getOptionLabel}
                    clearText="Очистить"
                    openText="Открыть список"
                    closeText="Закрыть список"
                    /*value={null}*/
                    getOptionKey={getOptionKey}
                    isOptionEqualToValue={isOptionEqualToValue}
                    getOptionDisabled={option => option.id < 0 /*|| selectedOptions.some(x => x.id === option.id)*/}
                    onChange={(event, value) => {
                        if (value) {
                            const newOption = {
                                ...value,
                                yearsValue: "",
                                yearsError: "",
                                uniqId: ++uniqIdCounter.current
                            }
                            handleSetSelectedOptions([...selectedOptions, newOption]);
                            setAutocompleteOpen(false);
                        }
                    }}
                    renderOption={(props2, option) => {
                        const {key, ...otherProps} = props2;

                        if (option.isHint) {
                            return (
                                <li key={key} {...otherProps}
                                    style={{
                                        display: "block",
                                        fontSize: "14px",
                                        color: "#844",
                                        fontStyle: "italic",
                                        opacity: "0.8"
                                    }}>
                                    <p style={{marginBottom: "-5px"}}>Показаны не все варианты!</p>
                                    <p>Уточните поисковый запрос</p>
                                </li>
                            );
                        }

                        if (option.isLoading) {
                            return (
                                <li key={key} {...otherProps}
                                    style={{display: "flex", gap: "10px", color: "#000", opacity: "0.6"}}>
                                    <CircularProgress color="inherit" size={20}/>
                                    Поиск вариантов...
                                </li>
                            );
                        }

                        if (option.isError) {
                            return (
                                <li key={key} {...otherProps}
                                    style={{
                                        display: "block",
                                        fontSize: "14px",
                                        color: "#844",
                                        fontStyle: "italic",
                                        opacity: "0.8"
                                    }}>
                                    <p style={{marginBottom: "-5px"}}>Не удалось запросить варианты!</p>
                                    <p>Попробуйте повторить поиск</p>
                                </li>
                            );
                        }

                        return (
                            <li key={key} {...otherProps}
                                style={{display: "flex", gap: "10px"}}>
                                {getOptionLabel(option)}
                                {renderItemExtraInfoFunc && renderItemExtraInfoFunc(option, cl.extraInfo, ownDataRefs)}
                                {showIds && option.id !== null && renderIdInfo(option.id)}
                            </li>
                        );
                    }}
                    onInputChange={(e, v, r) => {
                        //console.log("onInputChange! v=", v, "r=", r);
                        if (r === "input") {
                            setSearchQuery(v);
                            onFilterEdit();
                        }
                    }}
                    onClose={(event, reason) => {
                        setAutocompleteOpen(false);
                        rqIdCounter.current++;
                        setMainOptions([]);
                        setSearchQuery("");
                    }}
                /> :
                (readOnly ?
                    null :
                    <div className={cl.buttonsArea}>
                    {renderButton("Добавить", () => {
                        setAutocompleteOpen(true);
                        if (errorMessage) {
                            setErrorMessage("");
                        }
                        requestMainItems();
                    })}
                    {selectedOptions.length > 0 && renderButton("Очистить", () => {
                        handleSetSelectedOptions([]);
                    }, {borderColor: "gray", color: "#844"})}
                </div>)}
            {errorMessage &&
                <FormHelperText error sx={{marginLeft: "14px", marginTop: "2px"}}>{errorMessage}</FormHelperText>}
        </div>
    );
};

function renderIdInfo(id) {
    return <span className={cl.idInfo}>ID {id}</span>
}

function renderAutocompleteInput(params) {
    return <TextField
        {...params}
        placeholder="введите текст для поиска"
        autoFocus
        slotProps={{
            htmlInput: {
                ...params.inputProps,
                maxLength: 255,
            },
            input: {
                ...params.InputProps,
                sx: {
                    ...params.InputProps.sx,
                    backgroundColor: "white",
                    borderRadius: "4px"
                }
            },
        }}
    />
}

// TODO? shared?
function getInitialOptionName(optionId, refList, itemNameFunc) {
    if (optionId === null)
        return "-null-";

    if (optionId === 0)
        return "-id0-";

    if (optionId < 0)
        return "-negativeId-";

    const refItem = refList?.[optionId] ?? undefined;

    if (!refItem)
        return "-refItemNotFound-";

    const name = itemNameFunc ? itemNameFunc(refItem) : refItem.name;

    if (name)
        return name;

    return "-nameNotFound-";
}

function getYearsText(year1, year2) {
    return year1 ? (year2 ? `${year1}-${year2}` : String(year1)) : "";
}

function validateYearsText(text) {
    // "" or "YYYY" or "YYYY-YYYY"
    if (text === "")
        return true;

    const regex = /^(\d+)(\s*-\s*(\d+))?$/;
    const match = regex.exec(text.trim());
    if (!match)
        return false;

    const year1 = parseInt(match[1]);
    const year2 = match[3] ? parseInt(match[3]) : null;

    if (year1 < 1000 || year1 >= 3000)
        return false;

    if (year2 !== null) {
        if (year2 < 1000 || year2 >= 3000 || year2 <= year1)
            return false;
    }

    return true;
}

export default FormRewardsSelect;